import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  shareDialog: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing.space24,
  },
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: theme.radius.large,
    background:
      "radial-gradient(48.48% 48.48% at 48.53% 70.67%, #3F4042 4.63%, #101113 100%)",
    padding: "16px 20px",
    gap: theme.spacing.space16,
    alignSelf: "stretch",
  },
  closeIcon: {
    position: "fixed",
    top: theme.spacing.space24,
    insetInlineStart: theme.spacing.space24,
    color: theme.colors.TextDefault,
  },
  currentImage: {
    height: 100,
  },
  logo: {
    display: "flex",
    height: 30,
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing.space8,
    alignSelf: "stretch",
  },
  achievementText: {
    width: "271.192px",
    letterSpacing: "-1.2px",
    fontStyle: "normal",
    textAlign: "center",
  },
  achievementTitle: {
    width: "271.192px",
    fontStyle: "normal",
    textAlign: "center",
  },
  avatar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: "1 0 0",
    alignSelf: "stretch",
  },
  currentUser: {
    padding: "4px 16px 4px 4px",
    background: "#3F3F3F",
    display: "flex",
    borderRadius: "100px",
    gap: "6.635px",
    alignItems: "center",
  },
  userNameText: {
    textAlign: "center",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontStyle: "normal",
    lineHeight: "140% !important",
  },
  btnContent: {
    display: "flex",
    height: "50px",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
    gap: theme.spacing.space8,
    borderRadius: theme.spacing.space2,
    background: "var(--Foundation-Red-red-500, #E60000) !important",
  },
  btnText: {
    textAlign: "center",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontStyle: "normal",
    fontWeight: "600 !important",
    letterSpacing: "-0.9px",
  },
  background: {
    position: "absolute",
    width: "212.309px",
  },
}));
